module.exports = __webpack_public_path__ + "static/media/IMG_0220.d19b25ae.jpg";